import { Component, inject, input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ProductListItemDto } from '../../dtos/product-list-item.dto';
import { finalize } from 'rxjs/operators';
import { CustomerService } from '../../services/customer.service';
import { DEFAULT_ERROR_TEXT } from '../../constants';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { ProductLabelTypeEnum } from '../../enums/product-label-type.enum';
import { environment } from '../../../environments/environment';
import { RouterLinkWithLang } from '../../directives/router-link-with-lang/router-link-with-lang.directive';
import { NgClass } from '@angular/common';
import { ProductVariantsComponent } from '../product-variants/product-variants.component';
import { RatingStarsComponent } from '../rating-stars/rating-stars.component';
import { PreloaderComponent } from '../preloader/preloader.component';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { LoginModalComponent } from '../login-modal/login-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'product-list-item',
  templateUrl: './product-list-item.component.html',
  styleUrls: ['./product-list-item.component.scss'],
  imports: [NgClass, ProductVariantsComponent, RatingStarsComponent, PreloaderComponent, TranslatePipe, RouterLink, RouterLinkWithLang],
})
export class ProductListItemComponent implements OnInit, OnChanges {
  private customerService = inject(CustomerService);
  private analyticsService = inject(GoogleAnalyticsService);
  private dialog = inject(MatDialog);

  uploadedHost = environment.uploadedHost;
  error: string | null = null;
  isLoading: boolean = false;
  discountValue: number;
  get itemsCost(): number { return this.customerService.prices.itemsCost; }
  get activePriceIndex(): number {
    let _activePriceIndex;

    for (let i = this.item().discountedPrices.length - 1; i >= 0; i--) {
      if (this.itemsCost >= this.item().discountedPrices[i].costBreakpoint && !_activePriceIndex) {
        _activePriceIndex = i;
      }

      if (this.item().price >= this.item().discountedPrices[i].costBreakpoint && !_activePriceIndex) {
        _activePriceIndex = i;
      }
    }
    return _activePriceIndex;
  }

  get isLoggedIn() { return this.customerService.isLoggedIn; }

  readonly item = input<ProductListItemDto>(undefined);
  readonly parentNameForAnalytics = input<string>(undefined);

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    const item: ProductListItemDto = changes.item?.currentValue;
    if (item && item.oldPrice && !this.discountValue) {
      this.discountValue = Math.ceil((this.item().oldPrice - this.item().price) / this.item().oldPrice * 100);
    }
  }

  addToCart() {
    this.error = null;
    this.isLoading = true;

    this.customerService.addToCart(this.item().sku, 1)
      .pipe( finalize(() => this.isLoading = false) )
      .subscribe(
        _ => { },
        error => {
          this.error = error.error?.message || DEFAULT_ERROR_TEXT;
        }
      );

    this.analyticsService.addToCart(this.item().sku, this.item().name, this.item().price, this.parentNameForAnalytics());
  }

  toggleWishlistFlag() {
     this.customerService.toggleWishlistFlag(this.item().id ,this.item());
  }

  setItemThumbnail() {
    const item = this.item();
    if (!item.mediaUrl) {
      return '/assets/images/no-img.jpg';
    } else {
      return this.uploadedHost + item.mediaUrl;
    }
  }

  suggestToLogin () {
    this.dialog.open(LoginModalComponent);
  }

  public getLabelClass() {
    switch (this.item().label.type) {
      case ProductLabelTypeEnum.New:
        return 'item__label--new';
      case ProductLabelTypeEnum.Top:
        return 'item__label--top';
      case ProductLabelTypeEnum.Sale:
        return 'item__label--sale';
    }
  }
}
